import React, {useContext, createContext} from "react";

export const AppContext = createContext(null);
export const ColorModeContext = React.createContext({
    toggleColorMode: () => {
    }
});
//FIXME (mmilburn): There's probably a better way to do this.
export const GoogleMapsContext = createContext(null);

export const useGoogleMapsContext = () => {
  return useContext(GoogleMapsContext);
};

export const useColorModeContext = () => {
    return useContext(ColorModeContext);
};

export function useAppContext() {
    return useContext(AppContext);
}
